import { useMatches, useNavigate } from "react-router-dom"
import { Breadcrumb, BreadcrumbLink, StandardBreadcrumbs } from "../../../shared/components/links/StandardBreadcrumbs"
import { PageHeader } from "../../../shared/components/pageHeader/PageHeader"
import { LocalizedStrict } from "../../localization/components/AppLocalized"
import { Page } from "../../../shared/components/pageHeader/PageHeaderApi"
import { ChangePasswordForm } from "../components/ChangePasswordForm"
import { useApiMutation } from "../../../core/api/useApiMutation"
import { SuccessDisplay } from "../../../core/api/errorTypes"
import { getProfileRoute } from "../../../constants/routes"
import { isObjectWithProp } from "../../../lib/lang"
import { changePassword } from "../profileApi"

export const ChangePassword = () => {
    const navigate = useNavigate()

    const routeMatches = useMatches()
    const environmentRoutePath = routeMatches.find(
        (match) => isObjectWithProp(match.handle, "environmentRoot") && Boolean(match.handle.environmentRoot),
    )?.pathname

    const { mutate: callChangePassword } = useApiMutation(changePassword, {
        successDisplay: SuccessDisplay.SNACKBAR,
        async onSuccess() {
            navigate(getProfileRoute(environmentRoutePath))
        },
    })

    return (
        <>
            <LocalizedStrict id="profile-change-password-page-header" attrs={{ title: true }}>
                <PageHeader page={Page.CHANGE_PASSWORD} title="Change password">
                    <StandardBreadcrumbs>
                        <LocalizedStrict id="profile-nav-item-home">
                            <BreadcrumbLink to={"/"}>Home</BreadcrumbLink>
                        </LocalizedStrict>
                        <LocalizedStrict id="profile-user-info">
                            <BreadcrumbLink to={getProfileRoute(environmentRoutePath)}>User account</BreadcrumbLink>
                        </LocalizedStrict>
                        <LocalizedStrict id="profile-change-password">
                            <Breadcrumb>Change password</Breadcrumb>
                        </LocalizedStrict>
                    </StandardBreadcrumbs>
                </PageHeader>
            </LocalizedStrict>
            <ChangePasswordForm onSubmit={callChangePassword} />
        </>
    )
}
